import React, { Component } from 'react';
import { Card, message } from 'antd';
import Process from '@comm/workflow/Process';
import Modalshortfalls from '@comm/shortfalls';

import { queryBonusWorkflow, querySaveBonus } from '@api/hr/bonus';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
      shortData: '',
      visible: false,
    };
  }

  componentDidMount() {
    const { dataInfo } = this.state;
    this.setState({ dataInfo });
    this.bonusWorkflow();
  }

  /**
   * 提交报销
   */
  handSubmit = item => {
    this.saveBonus(item);
  };

  bonusWorkflow = params => {
    const { instance } = this.state;
    queryBonusWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  /**
   * 保存
   */
  saveBonus = item => {
    this.setState({
      isSubmitting: true,
    });
    querySaveBonus(item).then(res => {
      this.setState({
        isSubmitting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.go(-1);
      } else if (res.message.indexOf('\n') === -1) {
        message.error(res.message);
      } else {
        this.setState({
          shortData: res.message,
          visible: true,
        });
      }
    });
  };

  hideModal = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { isSubmitting, instance, shortData, visible } = this.state;
    return (
      <div>
        <FormBase
          data={this.state.dataInfo}
          handSubmit={this.handSubmit}
          isSubmitting={isSubmitting}
        />
        <Card>
          <Process instance={instance} />
        </Card>
        <Modalshortfalls data={shortData || ''} visible={visible} hideModal={this.hideModal} />
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/hr/bonus/PageAdd.js